module.exports = __webpack_public_path__ + "img/SMT_44_Mr_Lee_Keng_Leong.19742a29.jpg";